var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddition02 = function SvgAddition02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E6E6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 12.6v3.6h-1.2v-3.6H7.8v-1.2h3.6V7.8h1.2v3.6h3.6v1.2h-3.6Z",
    fill: "#151739"
  })));
};
export default SvgAddition02;